import React from 'react'

const DetailPayroll = (props) => {
  return (
    <div className='w-full h-screen grid-cols-1 bg-white sm:grid-cols-2'>
      <div className='w-full h-20 bg-real-white'>
        <div className='flex items-center h-full px-4'>
          <a href='/home'>
            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
          </a>
          <p className='px-4'>Januari 2024</p>
        </div>
      </div>
      <div className='w-full px-4 py-4 bg-real-white'>

      </div>

      <div className='w-full h-screen bg-white'>


        <div className='grid grid-cols-1'>
          <div className="p-4 mx-4 mt-4 rounded-lg bg-real-white">
            <p className='p-4 font-bold text-center border-b border-gray-100'>Payslip - Januari 2024</p>
            <div className='flex justify-between p-4 border-b border-gray-100 border-dashed'>
              <div className=''>
                <p>Siklus</p>
                <p>Periode</p>
                <p>Tanggal</p>
              </div>
              <div className='text-end'>
                <p>Bulanan</p>
                <p>Januari 2024</p>
                <p>25 Januari 2024</p>
              </div>


            </div>

            <div className='flex items-end justify-between p-4 border-b border-gray-100'>
              <div className=''>
                <p>Id Karyawan</p>
                <p>Nama Karyawan</p>
                <p>Divisi</p>
                <p>Pekerjaan</p>
              </div>
              <div className='text-end'>
                <p>123907901441</p>
                <p>Junaedi</p>
                <p>IT</p>
                <p>Back End Developer</p>
              </div>


            </div>

            <p className='p-4 font-bold border-b border-gray-100'>Parameter</p>

            <div className='flex justify-between p-4 border-b border-gray-100 border-dashed'>
                <p>Total Kehadiran</p>
                <p>17</p>
              </div>

              <div className='flex justify-between p-4 border-b border-gray-100 border-dashed'>
                <p>Total Tidak Kehadiran</p>
                <p>3</p>
              </div>

              <div className='flex justify-between p-4 border-b border-gray-100 border-dashed'>
                <p>Besar Pph 21 (1 bulan)</p>
                <p>Rp 6.250</p>
              </div>

              <div className='flex justify-between p-4 border-b border-gray-100 border-dashed'>
                <p>PTKP (1 bulan)</p>
                <p>Rp 125.000</p>
              </div>

              <div className='flex justify-between p-4 border-b border-gray-100 border-dashed'>
                <p>Pendapatan</p>
                <p>Rp 5.000.000</p>
              </div>

              <div className='flex justify-between p-4 font-bold border-b border-gray-100 border-dashed'>
                <p>Total Pendapatan</p>
                <p>Rp 4.250.000</p>
              </div>



            
          </div>


        </div>


      </div>


    </div >

  )
}

export default DetailPayroll